//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalProjectsProposedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Projects Proposed' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalProjectsProposedWidget;
